type Props = {
};

export const useTimeWindow = (props: Props) => {
  return {}
}